import React from 'react';

import { Tooltip } from 'antd';
import { SwitcherOutlined } from '@ant-design/icons';

import { IToolbarCommand } from '../../../../../../../models/Shopping';

const CommandSapView: React.FunctionComponent<IToolbarCommand> = ({ disabled, action }) => {
    const _handleCommandAction = () => {
        if (disabled || !action) {
            return;
        }

        action();
    }

    return (
        <div className={`command ${disabled && 'command-disabled'}`} onClick={_handleCommandAction}>
            <Tooltip title="Sap order details view">
                <SwitcherOutlined />
            </Tooltip>
        </div>
    );
}

export default CommandSapView;